import { Pipe, PipeTransform } from '@angular/core';
import { LegalDateTimeService } from '../services/legal-datetime.service';

@Pipe({
  name: 'legalDateCompare'
})
export class LegalDateComparePipe implements PipeTransform {
  constructor(private legalDate: LegalDateTimeService) {}

  transform(
    left: string | number | Date | null | undefined,
    operator: string,
    right: string | number | Date | null | undefined
  ): boolean {
    return this.legalDate.matches(left, operator, right);
  }
}
